import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

function Schedule() {
  return (
    <Timeline className='text-xl'>
      <TimelineItem>
        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} > 09:00 AM -  10:00 AM </span>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot sx={{ color: '#ff3456' }} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}> <span style={{ fontWeight: "bold" }}>Registration & Breakfast </span><br />
          <span>Welcome and registration of participants over wholesome sattvic breakfast.  </span>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} >10:00 AM - 1:00 PM</span>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>
          <span style={{ fontWeight: "bold" }}>Plenary Sessions </span><br />
          <span>Esteemed speakers will share insights on sustainability, consciousness, and culture. </span><br />
          <span style={{ fontWeight: "bold" }}>Radhanath Swami</span> - <span style={{ fontSize: "smaller" }} >Spiritual Leader & Visionary, Founder of Govardhan Ecovillage</span><br />
          <span style={{ fontWeight: "bold" }}>Gauranga Das</span> - <span style={{ fontSize: "smaller" }} >Director, Govardhan School of Sustainability</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Chetan Singh Solanki</span> - <span style={{ fontSize: "smaller" }} >Solar Man of India, Founder-Energy Swaraj</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Rajendra Singh</span> - <span style={{ fontSize: "smaller" }} >Water Man of India, Environmentalist</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Ranpal Singh</span> - <span style={{ fontSize: "smaller" }} >Group Head-Collaboration & Innovation, TATA Power </span> <br />
          <span style={{ fontWeight: "bold" }} > Shri Vishwanath Srikantaiah</span> - <span style={{ fontSize: "smaller" }} >Rain Man of Bengaluru, Environmentalist
          </span> <br />

        </TimelineContent>
      </TimelineItem>

      <TimelineItem>

        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} >1:00 PM - 2:00 PM</span>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold", fontFamily: "Cooper" }} >Lunch Break</span></TimelineContent>

      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} >2:00 PM - 4:00 PM</span>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>
          <span style={{ fontWeight: "bold" }}>Paper & Poster Presentations</span> <br />
          <span style={{ fontSize: "smaller" }} >Researchers and practitioners will present their work on sustainability, culture, and conscious living. </span>    <br />
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} >4:00 PM - 5:00 PM</span>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>
          <span style={{ fontWeight: "bold" }}>Panel Discussion: Innovations for a Sustainable Future</span><br />
          <span>An engaging dialogue among experts on renewable energy, water management, and conscious lifestyles.          </span><br />
          <span style={{ fontWeight: "bold" }}> Ms. Aarya Chavda</span> - <span style={{ fontSize: "smaller" }} >Author, Illustrator, Heritage & Environment Crusader</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Anuradda Ganesh</span> - <span style={{ fontSize: "smaller" }} >Adjunct Professor-IIT Madras, Director-Arantree Consulting</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Chandramouli Subramaniam</span> - <span style={{ fontSize: "smaller" }} >Professor-IIT Bombay, Co-Founder: NCF Green Energy</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Sachchida Nand Tripathi </span> - <span style={{ fontSize: "smaller" }} >Dean, Kotak School of Sustainability, IIT Kanpur</span><br />
          <span style={{ fontWeight: "bold" }}>Shri Vishal Sardeshpande</span> - <span style={{ fontSize: "smaller" }} >Jaggery Man of India, Founder-Sarvaay</span><br />


        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} >5:00 PM - 5:30 PM</span>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>
          <span style={{ fontWeight: "bold" }}>Concluding Remarks</span><br />
          <span style={{ fontWeight: "bold" }}>Gauranga Das Prabhu</span> - <span style={{ fontSize: "smaller" }} > Director, Govardhan School of Sustainability</span><br />

        </TimelineContent>
      </TimelineItem>


      <TimelineItem>
        <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
          <span style={{ fontWeight: "bold" }} >5:30 PM  - 6:00 PM
          </span>        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />

        </TimelineSeparator>
        <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}> <span style={{ fontWeight: "bold" }}>Vote of thanks</span></TimelineContent>
      </TimelineItem>

    </Timeline >

    //     <Timeline className='text-xl' >
    // <TimelineItem>
    //   <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //   <span style={{ fontWeight: "bold" }} > 09:00 AM -  10:00 AM </span>
    //   </TimelineOppositeContent>
    //   <TimelineSeparator>
    //     <TimelineDot sx={{ color: '#ff3456' }} />
    //     <TimelineConnector />
    //   </TimelineSeparator>
    //   <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>Registartion and Breakfast</TimelineContent>
    // </TimelineItem>
    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >10:00 AM - 10:10 AM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>Inauguration and Welcome</TimelineContent>
    //       </TimelineItem>

    // <TimelineItem>
    // <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //     <span style={{ fontWeight: "bold" }} >10:10 AM - 10:30 AM</span>
    //   </TimelineOppositeContent>
    //   <TimelineSeparator>
    //     <TimelineDot />
    //     <TimelineConnector />
    //   </TimelineSeparator>
    //   <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>Prof. Ganti S Murthy</span> - <span style={{ fontSize: "smaller" }} >IIT Indore, National Coordinator – IKS </span></TimelineContent>
    // </TimelineItem>
    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >10:30 AM - 10:50 AM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>Mr. Rama Kant</span></TimelineContent>
    //       </TimelineItem>
    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >10:50 AM - 11:10 AM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    // <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>
    //   <span style={{ fontWeight: "bold" }}>HH Radhanath Swami</span> - <span style={{ fontSize: "smaller" }} >Spiritual leader, Teacher, Author, Activist </span>
    //   </TimelineContent>
    //       </TimelineItem>

    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >11:10 PM - 11:30 PM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }} > Shri C.P Radha Krishnan</span> - <span style={{ fontSize: "smaller" }} >Governor of Maharashtra</span></TimelineContent>
    //       </TimelineItem>

    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >11:30 AM - 11:50 PM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    // <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>Prof. Vardaraj Bapat</span> - <span style={{ fontSize: "smaller" }} >IIT Bombay, SJMSOM </span></TimelineContent>
    //       </TimelineItem>

    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >11:50 AM - 12:00 PM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>Prof. Ganesh Ramakrishnan</span></TimelineContent>

    //       </TimelineItem>

    // <TimelineItem>

    //   <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //     <span style={{ fontWeight: "bold" }} >12:00 PM - 12:30 PM</span>
    //   </TimelineOppositeContent>
    //   <TimelineSeparator>
    //     <TimelineDot />
    //     <TimelineConnector />
    //   </TimelineSeparator>
    //   <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold", fontFamily: "Cooper" }} >Break</span></TimelineContent>

    // </TimelineItem>
    //       <TimelineItem>


    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >12:30 PM - 12:50 PM</span>
    //         </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>Ar. Hiten Sethi</span> - <span style={{ fontSize: "smaller" }} >Founder, HSA </span></TimelineContent>
    //       </TimelineItem>
    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >12:50 PM - 1:10 PM
    // </span>        </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>Shri S Gurumurthy</span> - <span style={{ fontSize: "smaller" }} >CA, Corporate & Legal Advisor </span> </TimelineContent>
    //       </TimelineItem> 




    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >1:10 PM - 1:40 PM
    //  </span>       </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />
    //           <TimelineConnector />
    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}><span style={{ fontWeight: "bold" }}>HG Gauranga Das</span> - <span style={{fontSize: "smaller" }} >Director, GEV </span> </TimelineContent>
    //       </TimelineItem>
    //       <TimelineItem>
    //         <TimelineOppositeContent sx={{ py: '12px', px: 2, color: '#226b1e' }}>
    //           <span style={{ fontWeight: "bold" }} >1:40 PM  - 1:50 PM
    // </span>        </TimelineOppositeContent>
    //         <TimelineSeparator>
    //           <TimelineDot />

    //         </TimelineSeparator>
    //         <TimelineContent sx={{ py: '12px', px: 2, color: '#010d82' }}>Vote of thanks</TimelineContent>
    //       </TimelineItem>
    //     </Timeline>
  );
}

export default Schedule;